import React from "react";
import ReceiptLongOutlinedIcon from "@mui/icons-material/ReceiptLongOutlined";

const CommonMmc = ({ data }) => {
  const planData = {
    name: data?.name ?? "",
    amount: data?.amount ?? "",
    gst: data?.gst ?? "",
    validity: data?.plan_days ?? "",
    total: data?.total_amount ?? "",
    freeValidity: data?.first_time_offer_days ?? "",
    id: data?.plan_id ?? "",
  };

  const type = "view";
  const inputOptions = [
    {
      id: 2,
      title: "Subscription Amount",
      subTitle: "(Month)",
      value: planData?.amount,
      accessor: "amount",
      type: "number",
      editable: type === "add",
    },
    {
      id: 3,
      title: "GST%",
      subTitle: "",
      value: planData?.gst,
      accessor: "gst",
      type: "number",
      editable: false,
    },
    {
      id: 4,
      title: "Plan Validity",
      subTitle: "(Days)",
      value: planData?.validity,
      accessor: "validity",
      type: "number",
      editable: type === "add",
    },
    {
      id: 5,
      title: "Total Amount",
      subTitle: "(Month)",
      value: planData?.total,
      accessor: "total",
      type: "number",
      editable: type === "add",
    },
    {
      id: 6,
      title: "Free Plan Validity",
      subTitle: "(Days)",
      value: planData?.freeValidity,
      accessor: "freeValidity",
      type: "number",
      editable: type === "add",
    },
    {
      id: 7,
      title: "Plan ID",
      subTitle: "",
      value: planData?.id,
      accessor: "id",
      type: "text",
      editable: false,
    },
  ];

  return (
    <div className="row mt-4 mb-4">
      {/* inputs  */}
      {inputOptions.map((item, ind) => {
        return (
          <div key={ind} className="col-md-6 mb-3">
            <p className="f3 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16">
              {item.title}{" "}
              {item.subTitle && (
                <span
                  className="f1 fs-sm-8 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14"
                  style={{ color: "#9A36E6" }}
                >
                  <i>{item.subTitle}</i>
                </span>
              )}
            </p>
            <input
              name="userName"
              type={item.type}
              value={item.value}
              className={`input-box mt-2 ${item.editable ? "" : "cursor"}`}
              placeholder={`Enter ${item.title}`}
              disabled={!item.editable}
            />
          </div>
        );
      })}

      {/* details  */}
      {planData?.hints && planData?.hints?.length !== 0 && (
        <div style={{ backgroundColor: "#F3F4F6" }} className=" rounded p-3">
          <h5 className="f4">Plan Details</h5>
          <hr className="p-2" />
          <ul className="mt-2">
            {planData?.hints?.map((item, index) => (
              <li key={index} className="d-flex as-jb gap-3 mt-2">
                <div className="d-flex as-js gap-3">
                  <ReceiptLongOutlinedIcon
                    htmlColor="#A855F7"
                    fontSize="small"
                  />
                  <p className="f2 fs-sm-10 fs-md-14 fs-lg-15 fs-xl-14 fs-xxl-16 text-start">
                    {item}
                  </p>
                </div>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default CommonMmc;
